module.exports = __webpack_public_path__ + "img/07.91a976c1.jpg";